import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { EstudianteActivoT, VoidEstudianteActivo } from "../../interfaces/SAAC/EstudianteActivo";
import { AyudantiaInvestigacion, CastSolicitudAyudanteInvToAyudantiaInvestigacion, CastTblDecInvProyectoAyud } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { useFormik } from "formik";
import { EstudianteActivoValidate, SolicitudAyudanteValidate } from "../ValidationForm/validationForm";
import { MdCancel, MdSave } from "react-icons/md";
import { CastAyudanteInvestigacionToSolicitudAyudanteInv, setSolicitudAyudanteInv, SolicitudAyudanteInv, voidSolicitudAyudanteInv } from "../../interfaces/AYUDANTIAS/SolicitudAyud";
import AcademicoService from "../../services/AcademicoService";
import { CatalogoInvestigador } from "../../interfaces/SAAC/CatalogoInvestigador";
import { boolean } from "yup";
import { PeriodoAcademico } from "../../interfaces/SAAC/PeriodoAcademico";
import AlertService from "../../services/AlertService";
import AyudantiaService from "../../services/AyudantiaService";

const academicoService = new AcademicoService();
const alertService = new AlertService();
const ayudantiaService = new AyudantiaService();

interface Props {
  estudiante : EstudianteActivoT;
  idProyecto : number;
  ayudantia: AyudantiaInvestigacion;
  token : any;
  periodoActivo : PeriodoAcademico;
  onResponse ? : (dataRespuesta : any) =>void;
  onClean?: (dataRespuesta: any) => void ;
  onClose?: () => void
  onChange?: () => void
}

export const SolicitarAyudForm: React.FC<Props> = ({  estudiante, token, ayudantia, idProyecto, onResponse , onClose, periodoActivo, onClean }) => {
  
  const [mensajes, setMensajes] = useState<Array<string>>([]);
  const [investigadores, setInvestigadores] = useState<Array<CatalogoInvestigador>>([]);

  useEffect(()=>{
    GetInvestigadores();

  },[estudiante]);

  const formik = useFormik<SolicitudAyudanteInv>({
    initialValues: ayudantia.proyectoAyud.iddecinvproyectoayud > 0 ? CastAyudanteInvestigacionToSolicitudAyudanteInv(ayudantia) : voidSolicitudAyudanteInv(),
    validationSchema: SolicitudAyudanteValidate,
    onSubmit: (values) => {
        var obj = setSolicitudAyudanteInv(values);
        //console.log(obj);
        if(obj.idsolicitud === 0){
            GuardarSolicitudIAyudante(obj);

        }else{
            if(onClose){
              onClose();
            }
            ActualizarSolicitudIAyudante(obj);
        }            
    }
  });

  const GuardarSolicitudIAyudante = async (values: SolicitudAyudanteInv) => {
    let obj = CastSolicitudAyudanteInvToAyudantiaInvestigacion(ayudantia,values, periodoActivo, idProyecto, estudiante);
    //console.log(obj);
    alertService.showLoading("Espere...");
    setMensajes([]);
    await ayudantiaService.PostSolicitudAyudantiaInvById(token, obj)
        .then((data) => {
            if (data.status.isSuccessfully) {
                if (onResponse) {
                    onResponse(data.data);
                    
                } else {
                    console.error('La función onResponse no está definida.');
                }
                //alertService.hideLoading();
                alertService.alertaExito('Éxito', 'Solicitud registrada.');
            } else {
                setMensajes(data.status.messages);
                //alertService.hideLoading();
                alertService.alertaAdvertenciaList('Alerta', data.status.messages[0].split('|').filter(msg => msg.trim() !== ''));
            }
        })
        .catch((error) => console.error(error));
  }

  const ActualizarSolicitudIAyudante = async (values: SolicitudAyudanteInv) => {

    //let obj = CastSolicitudAyudanteInvToAyudantiaInvestigacion(ayudantia,values, periodoActivo, idProyecto, estudiante);
    let obj = CastTblDecInvProyectoAyud(ayudantia.proyectoAyud, values);

    alertService.showLoading("Espere...");
    setMensajes([]);
    await ayudantiaService.UpdateSolicitudAyudantiaInvById(token, obj)
        .then((data) => {
            if (data.status.isSuccessfully) {
                if (onResponse) {
                    onResponse(data.data);
                } else {
                    console.error('La función onResponse no está definida.');
                }
                alertService.hideLoading();
                alertService.alertaExito('Éxito', 'Solicitud actualizada.');
            } else {
                setMensajes(data.status.messages);
                alertService.hideLoading();
                alertService.alertaAdvertenciaList('Alerta', data.status.messages[0].split('|').filter(msg => msg.trim() !== ''));
            }
        })
        .catch((error) => console.error(error));
  }

  const GetInvestigadores = async () => {
    await academicoService.GetCatalogoInvestigadores(token, periodoActivo.idperiodo, idProyecto, 'A')
        .then((data) => {
            //console.log(data.listData);
            setInvestigadores(data.listData);
        })
        .catch((error) => console.error(error));
  };

  return (
    <Container
      maxWidth="lg"
      sx={{
        border: "1px solid #E0E3EB",
        borderRadius: "12px",
        padding: "32px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          color: "#243165",
          marginBottom: "24px",
        }}
      >
        Solicitar Ayudante
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={4}>
          {/* Descripción */}
          <Grid item xs={12}>
            <FormControl sx = {{m: 1}} fullWidth error = {Boolean(formik.errors.descripcion && formik.touched.descripcion)}>
              <TextField
                label="Descripción de la necesidad"
                name="descripcion"
                id="descripcion"
                fullWidth
                multiline
                rows={3}
                value={formik.values.descripcion}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error = {formik.touched.descripcion && Boolean(formik.errors.descripcion)}
                placeholder="Ingrese una breve descripción..."
                sx={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
              />
              {
                formik.touched.descripcion && formik.errors.descripcion && (<Alert severity="error">{formik.errors.descripcion}</Alert>)
              }
            </FormControl>
          </Grid>

          {/* Horas */}
          <Grid item xs={12} sm={6}>
            <FormControl sx={{m : 1}} fullWidth error = {Boolean(formik.errors.horas && formik.touched.horas)}>
              <InputLabel htmlFor="select-horas">Horas</InputLabel>
              <Select
                labelId="select-horas"
                name="horas"
                label='Horas'
                //variant="outlined"
                value={formik.values.horas}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                sx={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
              >
                <MenuItem value="">Seleccione horas</MenuItem>
                <MenuItem value={'5'}>5</MenuItem>
                <MenuItem value={'10'}>10</MenuItem>
              </Select>
              {
                formik.touched.horas && formik.errors.horas && (<Alert severity="error">{formik.errors.horas}</Alert>)
              }
            </FormControl>
          </Grid>

          {/*termino*/}

          <Grid item xs={12} sm={12} md={6}>
            <FormControl sx={{ m: 1 }} fullWidth error={Boolean(formik.errors.termino && formik.touched.termino)} >
                <TextField
                    fullWidth
                    id="termino"
                    name="termino"
                    label="Término"
                    type="text"
                    value={periodoActivo.termino+"-"+periodoActivo.anio}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.termino && Boolean(formik.errors.termino)}
                    sx={{ marginBottom: '20px', width: '100%' }} // Ajuste del ancho del TextField
                    disabled
                />
                {formik.touched.termino && formik.errors.termino && (
                    <Alert severity="error">{formik.errors.termino}</Alert>
                )}
            </FormControl>
        </Grid>



          {/* Actividades */}
          <Grid item xs={12} sm ={12} md={12} >
            <FormControl sx ={{m: 1}}  fullWidth error={Boolean(formik.errors.actividades && formik.touched.actividades)} >
              <TextField
                label="Actividades a realizar"
                name="actividades"
                id="actividades"
                fullWidth
                multiline
                rows={3}
                placeholder="Describa las actividades..."
                value={formik.values.actividades}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.actividades && Boolean(formik.errors.actividades)}
                sx={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
              />
              {formik.touched.actividades && formik.errors.actividades && (
                                <Alert severity="error">{formik.errors.actividades}</Alert>
                            )}
            </FormControl>
          </Grid>

          {/* Responsable */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth sx={{m:1}} error={Boolean(formik.errors.docente && formik.touched.docente)} >
              <InputLabel htmlFor="select-docentes">Responsable de la ayudantía</InputLabel>
              <Select
                label="Responsable de la ayudantía"
                labelId="select-docentes"
                name="docente"
                variant="outlined"
                value={formik.values.docente}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                sx={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
              >
                {
                  investigadores.length> 0? (
                    investigadores.map((docente)=>(
                      <MenuItem key = {docente.email} value = {docente.email}>
                        {docente.label}
                      </MenuItem>
                    ))
                  ) : (<MenuItem value="">Seleccione un docente</MenuItem>)
                }
              </Select>
              {formik.touched.docente && formik.errors.docente && (
                  <Alert severity="error">{formik.errors.docente}</Alert>
              )}
            </FormControl>
          </Grid>

          {/* Financiamiento */}
          <Grid item xs={12} sm={6} md={6}>
            <FormControl component="fieldset" fullWidth error={Boolean(formik.errors.tipofinanciamiento && formik.touched.tipofinanciamiento)}>
              <FormLabel
                component="legend"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "8px",
                  color: "#243165",
                }}
              >
                Tipo de financiamiento de la ayudantía
              </FormLabel>
              <RadioGroup row 
                aria-label="tipofinanciamiento"
                name="tipofinanciamiento"  // El nombre debe coincidir con el campo de Formik
                value={formik.values.tipofinanciamiento}  // El valor proviene de Formik
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              
              >
                <FormControlLabel
                  value="0"
                  control={<Radio />}
                  label="Cupos de apoyo/ESPOL"
                />
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Fondos Proyectos"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Ad Honorem (Sin Pago al ayudante)"
                />
              </RadioGroup>
              {formik.touched.tipofinanciamiento && formik.errors.tipofinanciamiento && (
                  <Alert severity="error">{formik.errors.tipofinanciamiento}</Alert>
              )}
            </FormControl>
          </Grid>

          {/* Botón Guardar */}
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center", gap: "16px" }}>
              <Button
                variant="contained"
                
                color="primary"

                sx={{
                  marginRight: 1, backgroundColor: "#243165",
                  color: "#FFFFFF !important",
                  "&:hover": { backgroundColor: "#1e284c" },
                  boxShadow: 3,
                }}
                endIcon={<MdSave />}
                type="submit"
              >
                Guardar
              </Button>
              {/* <Button
                variant="contained"
                color="error"
                
                sx={{
                  marginRight: 1,
                  color: "#FFFFFF !important",
                  boxShadow: 3,
                }}
                onClick={onClean}
                endIcon={<MdCancel />}
               
              >
                Cancelar
              </Button> */}
            </Box>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};



// function CastAyudanteInvestigacionToSolicitudAyudanteInv(ayudantia: AyudantiaInvestigacion): SolicitudAyudanteInv {
//   throw new Error("Function not implemented.");
// }

